import { useCallback } from 'react';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { defaultSaveField } from '@atlassian/jira-issue-field-base/src/services/edit-field-service/utils';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';

const JWM_BOARD_ISSUE_FIELD_UPDATE = 'jwmBoardIssueFieldUpdate';

/** @deprecated To be deleted when jwm.board-awesome-enhancements is cleaned up */
export const useUpdateIssueField = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return useCallback(
		async <T,>({
			issueKey,
			fieldKey,
			newValue,
		}: {
			issueKey: string;
			fieldKey: string;
			newValue: T;
		}) =>
			defaultSaveField(issueKey, fieldKey, newValue, '')
				.then((response) => {
					fireOperationalAnalytics(
						createAnalyticsEvent({}),
						`${JWM_BOARD_ISSUE_FIELD_UPDATE} succeeded`,
						{ field: fieldKey.startsWith('customfield_') ? 'category' : fieldKey },
					);
					return response;
				})
				.catch((error) => {
					fireErrorAnalytics({
						meta: {
							id: JWM_BOARD_ISSUE_FIELD_UPDATE,
							packageName: 'jiraWorkManagementBoard',
							teamName: 'wanjel',
						},
						attributes: {
							message: `${JWM_BOARD_ISSUE_FIELD_UPDATE} failed`,
							field: fieldKey.startsWith('customfield_') ? 'category' : fieldKey,
						},
						error,
						sendToPrivacyUnsafeSplunk: true,
					});
					throw error;
				}),
		[createAnalyticsEvent],
	);
};
